import React, { useContext, useMemo, ReactNode } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { useStaticQuery, graphql } from "gatsby";
import { HeaderHeightStateContext } from "../../context/headerHeightContext";
import clsx from "clsx";
import { WindowLocation } from "@reach/router";
import { Toaster } from "@/components/ui/sonner";
import './layout.css';
import { useScrolled } from "@/hooks/useScrolled";

const Layout = ({
  location,
  children,
}: {
  location: WindowLocation;
  children: ReactNode;
}) => {
  const {
    // wp: {
    //   generalSettings: { title },
    // },
    allWpContactInfoItem: {
      settingList: [firstSettingGroup],
    },
    logoOld,
  } = useStaticQuery(graphql`
    query LayoutQuery {
      wp {
        generalSettings {
          title
          description
        }
      }
      allWpContactInfoItem(limit: 1) {
        settingList: nodes {
          contactInfo {
            addressLink
            addressLinkExternal
            addressText
            facebookLink
            instagramLink
            instagramName
            youtubeLink
            youtubeName
            email
            fieldGroupName
            phone
            phoneText
            workingTime
          }
        }
      }
      logoOld: file(relativePath: { eq: "logo-old.png" }) {
        publicURL
      }
    }
  `);
  const { contactInfo } = firstSettingGroup;
  const scrolled = useScrolled(20);
  const headerHeight = useContext(HeaderHeightStateContext);
  const isHomePage = useMemo(() => location.pathname === "/", [location]);

  return (
    <div
      data-is-root-path={isHomePage}
      className={clsx(
        'flex flex-col min-h-screen bg-white',
        !isHomePage &&
          'layoutBg mui-md:bg-no-repeat bg-[#f7f7f7] bg-[bottom_-33px_left_calc(50%+120px)]'
      )}
    >
      <Header
        contactInfo={contactInfo}
        logoOld={logoOld.publicURL}
        location={location}
        scrolled={scrolled}
      />
      <main
        className="grow min-h-screen"
        style={{
          marginTop: !isHomePage && scrolled ? headerHeight : 0,
        }}
      >
        {children}
      </main>
      <Footer contactInfo={contactInfo} logoOld={logoOld.publicURL} />
      <Toaster theme="light" />
    </div>
  );
};

export default Layout;
